import React from 'react';
import { motion } from 'framer-motion';
import ReactECharts from 'echarts-for-react';
import { LINEAGE_GRAPH_DATA } from '../../data/mockData';
import SafeIcon from '../../common/SafeIcon';
import { FiMaximize, FiFilter } from 'react-icons/fi';

export default function Lineage() {
  const option = {
    backgroundColor: 'transparent',
    tooltip: {
      formatter: function (params) {
        if(params.dataType === 'node') {
            return `<div style="background: #0a1324; border: 1px solid #1a2f52; padding: 10px; border-radius: 4px; color: #f0f4f8;">
                      <strong style="color: #00e5ff">${params.data.name}</strong><br/>
                      Type: ${params.data.value}<br/>
                      Zone: ${LINEAGE_GRAPH_DATA.categories[params.data.category].name}
                    </div>`;
        }
        return '';
      }
    },
    legend: [{
      data: LINEAGE_GRAPH_DATA.categories.map(a => a.name),
      textStyle: { color: 'var(--pearl-muted)' },
      bottom: 0
    }],
    animationDuration: 1500,
    animationEasingUpdate: 'quinticInOut',
    series: [
      {
        name: 'Data Lineage',
        type: 'graph',
        layout: 'none',
        data: LINEAGE_GRAPH_DATA.nodes.map(node => ({
          ...node,
          x: node.category * 300,
          y: (Math.random() * 200) - 100, // Pseudo-random vertical positioning for visual spread
          itemStyle: {
            color: node.category === 0 ? '#48cae4' : node.category === 1 ? '#0077b6' : node.category === 2 ? '#00e5ff' : '#00b4d8',
            borderColor: '#0a1324',
            borderWidth: 2,
            shadowBlur: 10,
            shadowColor: 'rgba(0, 229, 255, 0.5)'
          }
        })),
        links: LINEAGE_GRAPH_DATA.links.map(link => ({
            ...link,
            lineStyle: {
                color: 'var(--schema-teal)',
                opacity: 0.4,
                width: 2,
                curveness: 0.3
            }
        })),
        categories: LINEAGE_GRAPH_DATA.categories,
        roam: true,
        label: {
          show: true,
          position: 'right',
          formatter: '{b}',
          color: 'var(--pearl)',
          fontSize: 12
        },
        lineStyle: { color: 'source', curveness: 0.3 },
        emphasis: {
          focus: 'adjacency',
          lineStyle: { width: 4, opacity: 1, color: '#00e5ff' },
          itemStyle: { shadowBlur: 20 }
        }
      }
    ]
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="h-full flex flex-col">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h2 className="text-2xl font-bold text-[var(--pearl)] mb-1">Lineage Paths</h2>
          <p className="text-[var(--pearl-muted)] text-sm">Trace the flow of data across the harbor.</p>
        </div>
        <div className="flex gap-2">
            <button className="btn-secondary flex items-center gap-2"><SafeIcon icon={FiFilter}/> Sector Filter</button>
            <button className="btn-secondary p-2"><SafeIcon icon={FiMaximize}/></button>
        </div>
      </div>

      <div className="glass-panel flex-1 relative overflow-hidden">
        <div className="absolute top-4 left-4 z-10 p-4 bg-[var(--bg-ocean)]/80 backdrop-blur border border-[var(--border-ocean)] rounded-lg">
            <h4 className="text-sm font-semibold text-[var(--schema-teal)] mb-2">Graph Controls</h4>
            <div className="flex flex-col gap-2 text-xs text-[var(--pearl-muted)]">
                <label className="flex items-center gap-2"><input type="checkbox" defaultChecked className="accent-[var(--schema-teal)]"/> Show Transformations</label>
                <label className="flex items-center gap-2"><input type="checkbox" defaultChecked className="accent-[var(--schema-teal)]"/> Show PII Tags</label>
            </div>
        </div>
        <ReactECharts option={option} style={{ height: '100%', width: '100%' }} />
      </div>
    </motion.div>
  );
}